module.exports = __webpack_public_path__ + "static/fonts/materialdesignicons-webfont.27cb2cf1.woff2";